  export const Qualification = [
      {year: 2008, degree: "High School", institute: "Army School Faizabad"},
      {year: 2011, degree:"Secondary School", intitute: "Udaya Public School"},
      {year: 2016, degree:"Computer Science Engineering", institute:"ABES Engineering College"}
  ]

  export const jobs1=[
    "-Maintain their website as an administrator."
    ,"-Responding to their mails."
    ,"-Computer maintenance."
    ,"-Generating hotels and sightseeing vouchers."
    ,"-Providing quotes to the clients"
    ,"-Group reservation agent"
    ,"-Processes reservations from the sales office, other hotel departments, and travel agents."
    ,"-Knows the type of rooms available as well as their location and layout."
    ,"-Knows the credit policy of the hotel and how to code each reservation."
    ,"-Creates and maintains reservation records by date of arrival and alphabetical listing."
    ,"-Determines room rates based on the selling tactics of the hotel."
    ,"-Prepares letters of confirmation."
    ,"-Communicates reservation information to the front desk."
    ,"-Processes cancellations and modifications and promptly relays this information to the front desk."
  ]
  export const jobs2 =[     
    "-Support the Product Director as required"
    ,"-Manage the Itineraries, Factsheets and subsequent documents on Travel Trade to ensure all Travel"
    ,"-Trade products are up to date and formatted in accordance with company standards"
    ,"-Work with the local Destination teams to ensure timely upload of new Products and Validities"
    ,"-Learn about the Product and Group Product process for these destinations"
    ,"-Maintain current Spreadsheets for product loading"
    ,"-Manage workflows and emails using Exo24"
    ,"-Work on additional projects as required by the Product Director"
  ]

  export const jobs3=[
        "- Students learning projection and progress."
        ,"- Worksheet, test, and exam examples."
        ,"- Detailed notes on topics taught."
        ,"- Project and importance."
  ]
  export const experience = [
    {year: "from 2019 January till now", Position:"Computer and Mathematics Teacher",  company: "Chomsurang Upatham School", jobs: jobs3,},
    {year: "2017 September to 2017 January", Position:"Product Officer", company: "Exo Travel", jobs: jobs2,},  
    {year: "2017 January to 2017 September", Position:"Reservation Exicutive", company: "The Thai Star", jobs: jobs1}
  ]

  export const hobbies = ["Learn new technologies","Teaching.","Interested in playing football and Net surfing.","Listening to music.","Playing video games."]  

  export const os = [ "Windows" , "Ubuntu" , "macOS"];

  export const webDevelopment = ["HTML" , "CSS" , "JavaScript" , "ReactJS", "Github" ];

  export const misc = ["Google Sheets","Google Docs","Google Drive","Google Slides","Google Classroom","Jam Board","Microsoft Word","Microsoft Outlook","Microsoft Excel","Microsoft PowerPoint"];

  export const lang = ["English", "Hindi" , "Awadhi" , "Thai"];

  export const detail = ["FATHER’S NAME: Mr. Hari Prasad Jaiswal","MOTHER’S NAME: Mrs. Sudha Devi Jaiswal","NATIONALITY: Thai","MARITAL STATUS: Single"];